import React from 'react';

import cn from 'classnames';

import {getDiffInDays, getFormattedDate, IDateOptions} from 'shared/lib/datetime';

import styles from './DateWithColorWarnings.module.scss';

interface IDateWithColorWarningsProps {
    dateString?: Date | string | null,
    options?: IDateOptions,
    warningLevel?: number,
    criticalLevel?: number,
}

const DateWithColorWarnings: React.FC<IDateWithColorWarningsProps> = ({
    dateString,
    options,
    warningLevel = 30,
    criticalLevel = 5,
}) => {
    const content = getFormattedDate(dateString, options);

    if (!dateString) {
        return <>{content}</>;
    }

    const diffDays = getDiffInDays(dateString, new Date());
    let className = '';

    if (diffDays <= warningLevel) {
        className = 'warning';
    }

    if (diffDays <= criticalLevel) {
        className = 'danger';
    }

    if (!className) {
        return <>{content}</>;
    }

    return (
        <span className={cn(styles[className], styles.text)}>
            {content}
        </span>
    );
};

export default DateWithColorWarnings;
